[
  {
    "id": "bs-achtung",
    "abschnitt": "A",
    "fundstelle": "§ 4.02 Nummer 1, Anlage 6 Abschnitt A",
    "name": {
      "de": "1 langer Ton",
      "en": "One long blast"
    },
    "pattern": [
      {
        "kind": "lang",
        "count": 1
      }
    ],
    "repeatS": 0,
    "bedeutung": "Achtung",
    "erklaerung": "Ein langer Ton ruft Aufmerksamkeit auf sich, ohne eine Absicht anzukündigen. Er ist das Zeichen, mit dem sich ein Fahrzeug bemerkbar macht, bevor es etwas tut oder verlangt.",
    "kleinfahrzeug": true,
    "lichtzeichen": true
  },
  {
    "id": "bs-kurs-stb",
    "abschnitt": "A",
    "fundstelle": "§ 4.02 Nummer 1, Anlage 6 Abschnitt A",
    "name": {
      "de": "1 kurzer Ton",
      "en": "One short blast"
    },
    "pattern": [
      {
        "kind": "kurz",
        "count": 1
      }
    ],
    "repeatS": 0,
    "bedeutung": "Ich richte meinen Kurs nach Steuerbord",
    "erklaerung": "Ein kurzer Ton meldet einen Kurswechsel nach Steuerbord. Dasselbe Zeichen heißt bei der Begegnung etwas anderes: dort verlangt es die Vorbeifahrt an Backbord. Welche Bedeutung gilt, sagt die Lage.",
    "kleinfahrzeug": true,
    "lichtzeichen": true
  },
  {
    "id": "bs-kurs-bb",
    "abschnitt": "A",
    "fundstelle": "§ 4.02 Nummer 1, Anlage 6 Abschnitt A",
    "name": {
      "de": "2 kurze Töne",
      "en": "Two short blasts"
    },
    "pattern": [
      {
        "kind": "kurz",
        "count": 2
      }
    ],
    "repeatS": 0,
    "bedeutung": "Ich richte meinen Kurs nach Backbord",
    "erklaerung": "Zwei kurze Töne melden einen Kurswechsel nach Backbord. Auch dieses Zeichen hat bei der Begegnung eine zweite Bedeutung: dort verlangt es die Vorbeifahrt an Steuerbord.",
    "kleinfahrzeug": true,
    "lichtzeichen": true
  },
  {
    "id": "bs-rueckwaerts",
    "abschnitt": "A",
    "fundstelle": "§ 4.02 Nummer 1, Anlage 6 Abschnitt A",
    "name": {
      "de": "3 kurze Töne",
      "en": "Three short blasts"
    },
    "pattern": [
      {
        "kind": "kurz",
        "count": 3
      }
    ],
    "repeatS": 0,
    "bedeutung": "Meine Maschine geht rückwärts",
    "erklaerung": "Drei kurze Töne sagen, dass die Maschine rückwärts arbeitet. Das Fahrzeug verliert Fahrt oder fährt zurück, und wer hinter ihm liegt, muss damit rechnen.",
    "kleinfahrzeug": true,
    "lichtzeichen": true
  },
  {
    "id": "bs-manoevrierunfaehig",
    "abschnitt": "A",
    "fundstelle": "§ 4.02 Nummer 1, Anlage 6 Abschnitt A",
    "name": {
      "de": "4 kurze Töne",
      "en": "Four short blasts"
    },
    "pattern": [
      {
        "kind": "kurz",
        "count": 4
      }
    ],
    "repeatS": 0,
    "bedeutung": "Ich bin manövrierunfähig",
    "erklaerung": "Vier kurze Töne melden, dass das Fahrzeug nicht mehr ausweichen kann. Die anderen müssen ihm ausweichen, denn es selbst kann es nicht mehr.",
    "kleinfahrzeug": true,
    "lichtzeichen": true
  },
  {
    "id": "bs-gefahr",
    "abschnitt": "A",
    "fundstelle": "§ 4.02 Nummer 1, Anlage 6 Abschnitt A",
    "name": {
      "de": "Folge sehr kurzer Töne",
      "en": "Series of very short blasts"
    },
    "pattern": [
      {
        "kind": "sehr-kurz",
        "count": 6
      }
    ],
    "repeatS": 0,
    "bedeutung": "Gefahr eines Zusammenstoßes",
    "erklaerung": "Mindestens sechs sehr kurze Töne, je eine Viertelsekunde, warnen vor einem drohenden Zusammenstoß. Es ist das dringendste der Allgemeinen Zeichen und verlangt sofortiges Handeln.",
    "kleinfahrzeug": true,
    "lichtzeichen": true
  },
  {
    "id": "bs-not-toene",
    "abschnitt": "A",
    "fundstelle": "§ 4.04 Nummer 1",
    "name": {
      "de": "Wiederholte lange Töne",
      "en": "Repeated long blasts"
    },
    "pattern": [
      {
        "kind": "lang",
        "count": 2
      }
    ],
    "repeatS": 1,
    "bedeutung": "Notsignal",
    "erklaerung": "Wiederholte lange Töne rufen Hilfe herbei, besonders wenn das Fahrzeug in Not oder ein Mensch über Bord gefallen ist (§ 4.04 Nummer 1). Sie ersetzen oder ergänzen die Notzeichen, die man sehen kann.",
    "kleinfahrzeug": true,
    "lichtzeichen": true
  },
  {
    "id": "bs-not-glocke",
    "abschnitt": "A",
    "fundstelle": "§ 4.04 Nummer 1",
    "name": {
      "de": "Gruppe von Glockenschlägen",
      "en": "Group of bell strokes"
    },
    "pattern": [
      {
        "kind": "glocke",
        "count": 1
      }
    ],
    "repeatS": 0,
    "bedeutung": "Notsignal",
    "erklaerung": "Statt der langen Töne darf das Fahrzeug auch mit der Glocke läuten: § 4.04 Nummer 1 stellt beides zur Wahl, für dieselbe Lage, Not oder Mensch über Bord. Ein Lichtzeichen begleitet die Glocke nicht.",
    "kleinfahrzeug": true,
    "lichtzeichen": false
  },
  {
    "id": "bs-bleib-weg",
    "abschnitt": "A",
    "fundstelle": "§ 8.09 Nummer 2 in Verbindung mit Nummer 1",
    "name": {
      "de": "Mindestens 15 Minuten lang ununterbrochene Wiederholung abwechselnd eines kurzen und eines langen Tones in Verbindung mit dem Lichtzeichen nach § 4.01 Nummer 2",
      "en": "Short and long blasts alternating, for at least 15 minutes"
    },
    "pattern": [
      {
        "kind": "kurz",
        "count": 1
      },
      {
        "kind": "lang",
        "count": 1
      }
    ],
    "repeatS": 1,
    "bedeutung": "Bleib-Weg-Signal",
    "erklaerung": "Kurz und lang im Wechsel, mindestens fünfzehn Minuten lang und zusammen mit dem gelben Lichtzeichen: das Bleib-Weg-Signal nach § 8.09. Es warnt andere Fahrzeuge, sich zu nähern, etwa wenn gefährliche Güter austreten.",
    "kleinfahrzeug": true,
    "lichtzeichen": true
  },
  {
    "id": "bs-begegnen-bb-verlangt",
    "abschnitt": "B",
    "fundstelle": "§ 6.04 Nummer 4 Buchstabe a",
    "name": {
      "de": "1 kurzer Ton",
      "en": "One short blast"
    },
    "pattern": [
      {
        "kind": "kurz",
        "count": 1
      }
    ],
    "repeatS": 0,
    "bedeutung": "Ich will an Backbord vorbeifahren",
    "erklaerung": "Ein kurzer Ton des Bergfahrers verlangt die Begegnung Backbord an Backbord. Der Talfahrer antwortet darauf: mit demselben Zeichen, wenn er einverstanden ist.",
    "lage": "Vorbeifahrt an Backbord verlangt",
    "wer": "bergfahrer",
    "kleinfahrzeug": false,
    "lichtzeichen": true
  },
  {
    "id": "bs-begegnen-bb-einverstanden",
    "abschnitt": "B",
    "fundstelle": "§ 6.04 Nummer 5",
    "name": {
      "de": "1 kurzer Ton",
      "en": "One short blast"
    },
    "pattern": [
      {
        "kind": "kurz",
        "count": 1
      }
    ],
    "repeatS": 0,
    "bedeutung": "Einverstanden, fahren Sie an Backbord vorbei",
    "erklaerung": "Der Talfahrer wiederholt den kurzen Ton und stimmt damit zu. Beide fahren Backbord an Backbord aneinander vorbei, so wie der Bergfahrer es verlangt hat.",
    "lage": "Vorbeifahrt an Backbord verlangt",
    "fall": "normal",
    "wer": "talfahrer",
    "antwortAuf": "bs-begegnen-bb-verlangt",
    "kleinfahrzeug": false,
    "lichtzeichen": true
  },
  {
    "id": "bs-begegnen-bb-abgelehnt",
    "abschnitt": "B",
    "fundstelle": "§ 6.05 Nummer 2 Buchstabe b",
    "name": {
      "de": "2 kurze Töne",
      "en": "Two short blasts"
    },
    "pattern": [
      {
        "kind": "kurz",
        "count": 2
      }
    ],
    "repeatS": 0,
    "bedeutung": "Nicht einverstanden, fahren Sie an Steuerbord vorbei",
    "erklaerung": "Mit zwei kurzen Tönen widerspricht der Talfahrer und verlangt die andere Seite. Der Bergfahrer muss das bestätigen, bevor die Begegnung geklärt ist.",
    "lage": "Vorbeifahrt an Backbord verlangt",
    "fall": "abweichung",
    "wer": "talfahrer",
    "antwortAuf": "bs-begegnen-bb-verlangt",
    "kleinfahrzeug": false,
    "lichtzeichen": true
  },
  {
    "id": "bs-begegnen-bb-abgelehnt-bestaetigt",
    "abschnitt": "B",
    "fundstelle": "§ 6.05 Nummer 3 Buchstabe b",
    "name": {
      "de": "2 kurze Töne",
      "en": "Two short blasts"
    },
    "pattern": [
      {
        "kind": "kurz",
        "count": 2
      }
    ],
    "repeatS": 0,
    "bedeutung": "Einverstanden, ich werde an Steuerbord vorbeifahren",
    "erklaerung": "Der Bergfahrer gibt die zwei kurzen Töne zurück und nimmt den Widerspruch an. Erst damit ist klar, dass beide Steuerbord an Steuerbord fahren.",
    "lage": "Vorbeifahrt an Backbord verlangt",
    "fall": "abweichung",
    "wer": "bergfahrer",
    "antwortAuf": "bs-begegnen-bb-abgelehnt",
    "kleinfahrzeug": false,
    "lichtzeichen": true
  },
  {
    "id": "bs-begegnen-stb-verlangt",
    "abschnitt": "B",
    "fundstelle": "§ 6.04 Nummer 4 Buchstabe b",
    "name": {
      "de": "2 kurze Töne",
      "en": "Two short blasts"
    },
    "pattern": [
      {
        "kind": "kurz",
        "count": 2
      }
    ],
    "repeatS": 0,
    "bedeutung": "Ich will an Steuerbord vorbeifahren",
    "erklaerung": "Zwei kurze Töne des Bergfahrers verlangen die Begegnung Steuerbord an Steuerbord. Der Talfahrer antwortet mit demselben Zeichen, wenn er einverstanden ist.",
    "lage": "Vorbeifahrt an Steuerbord verlangt",
    "wer": "bergfahrer",
    "kleinfahrzeug": false,
    "lichtzeichen": true
  },
  {
    "id": "bs-begegnen-stb-einverstanden",
    "abschnitt": "B",
    "fundstelle": "§ 6.04 Nummer 5",
    "name": {
      "de": "2 kurze Töne",
      "en": "Two short blasts"
    },
    "pattern": [
      {
        "kind": "kurz",
        "count": 2
      }
    ],
    "repeatS": 0,
    "bedeutung": "Einverstanden, fahren Sie an Steuerbord vorbei",
    "erklaerung": "Der Talfahrer wiederholt die zwei kurzen Töne und stimmt zu. Die Fahrzeuge begegnen sich Steuerbord an Steuerbord.",
    "lage": "Vorbeifahrt an Steuerbord verlangt",
    "fall": "normal",
    "wer": "talfahrer",
    "antwortAuf": "bs-begegnen-stb-verlangt",
    "kleinfahrzeug": false,
    "lichtzeichen": true
  },
  {
    "id": "bs-begegnen-stb-abgelehnt",
    "abschnitt": "B",
    "fundstelle": "§ 6.05 Nummer 2 Buchstabe a",
    "name": {
      "de": "1 kurzer Ton",
      "en": "One short blast"
    },
    "pattern": [
      {
        "kind": "kurz",
        "count": 1
      }
    ],
    "repeatS": 0,
    "bedeutung": "Nicht einverstanden, fahren Sie an Backbord vorbei",
    "erklaerung": "Mit einem kurzen Ton widerspricht der Talfahrer und verlangt die Begegnung Backbord an Backbord. Der Bergfahrer muss das bestätigen.",
    "lage": "Vorbeifahrt an Steuerbord verlangt",
    "fall": "abweichung",
    "wer": "talfahrer",
    "antwortAuf": "bs-begegnen-stb-verlangt",
    "kleinfahrzeug": false,
    "lichtzeichen": true
  },
  {
    "id": "bs-begegnen-stb-abgelehnt-bestaetigt",
    "abschnitt": "B",
    "fundstelle": "§ 6.05 Nummer 3 Buchstabe a",
    "name": {
      "de": "1 kurzer Ton",
      "en": "One short blast"
    },
    "pattern": [
      {
        "kind": "kurz",
        "count": 1
      }
    ],
    "repeatS": 0,
    "bedeutung": "Einverstanden, ich werde an Backbord vorbeifahren",
    "erklaerung": "Der Bergfahrer gibt den kurzen Ton zurück und nimmt den Widerspruch an. Beide fahren nun Backbord an Backbord aneinander vorbei.",
    "lage": "Vorbeifahrt an Steuerbord verlangt",
    "fall": "abweichung",
    "wer": "bergfahrer",
    "antwortAuf": "bs-begegnen-stb-abgelehnt",
    "kleinfahrzeug": false,
    "lichtzeichen": true
  },
  {
    "id": "bs-ueberholen-bb-verlangt",
    "abschnitt": "C",
    "fundstelle": "§ 6.10 Nummer 2 Buchstabe a",
    "name": {
      "de": "2 lange Töne, 2 kurze Töne",
      "en": "Two long blasts, two short blasts"
    },
    "pattern": [
      {
        "kind": "lang",
        "count": 2
      },
      {
        "kind": "kurz",
        "count": 2
      }
    ],
    "repeatS": 0,
    "bedeutung": "Ich will auf Ihrer Backbordseite überholen",
    "erklaerung": "Zwei lange und zwei kurze Töne kündigen das Überholen auf der Backbordseite des Vorausfahrenden an. Überholt wird erst, wenn der Vorausfahrende nicht widerspricht.",
    "lage": "Überholen an Backbord des Vorausfahrenden verlangt",
    "wer": "ueberholender",
    "kleinfahrzeug": false,
    "lichtzeichen": true
  },
  {
    "id": "bs-ueberholen-bb-einverstanden",
    "abschnitt": "C",
    "fundstelle": "§ 6.10 Nummer 3",
    "name": {
      "de": "Kein Zeichen",
      "en": "No signal"
    },
    "pattern": [],
    "repeatS": 0,
    "bedeutung": "Einverstanden, Sie können auf meiner Backbordseite überholen",
    "erklaerung": "Hier ist das Schweigen die Antwort: gibt der Vorausfahrende kein Zeichen, ist er einverstanden. Das steht ausdrücklich in § 6.10 Nummer 3 und ist keine Lücke der Tabelle.",
    "lage": "Überholen an Backbord des Vorausfahrenden verlangt",
    "fall": "normal",
    "wer": "vorausfahrender",
    "antwortAuf": "bs-ueberholen-bb-verlangt",
    "kleinfahrzeug": false,
    "lichtzeichen": false
  },
  {
    "id": "bs-ueberholen-bb-abgelehnt",
    "abschnitt": "C",
    "fundstelle": "§ 6.10 Nummer 4 Satz 1 Buchstabe b",
    "name": {
      "de": "2 kurze Töne",
      "en": "Two short blasts"
    },
    "pattern": [
      {
        "kind": "kurz",
        "count": 2
      }
    ],
    "repeatS": 0,
    "bedeutung": "Nicht einverstanden, überholen Sie auf meiner Steuerbordseite",
    "erklaerung": "Zwei kurze Töne des Vorausfahrenden verlangen die andere Seite. Der Überholende muss bestätigen, bevor er an Steuerbord vorbeizieht.",
    "lage": "Überholen an Backbord des Vorausfahrenden verlangt",
    "fall": "abweichung",
    "wer": "vorausfahrender",
    "antwortAuf": "bs-ueberholen-bb-verlangt",
    "kleinfahrzeug": false,
    "lichtzeichen": true
  },
  {
    "id": "bs-ueberholen-bb-abgelehnt-bestaetigt",
    "abschnitt": "C",
    "fundstelle": "§ 6.10 Nummer 4 Satz 2 Buchstabe b",
    "name": {
      "de": "1 kurzer Ton",
      "en": "One short blast"
    },
    "pattern": [
      {
        "kind": "kurz",
        "count": 1
      }
    ],
    "repeatS": 0,
    "bedeutung": "Einverstanden, ich werde auf Ihrer Steuerbordseite überholen",
    "erklaerung": "Ein kurzer Ton des Überholenden nimmt den Wunsch des Vorausfahrenden an. Er überholt nun auf der Steuerbordseite.",
    "lage": "Überholen an Backbord des Vorausfahrenden verlangt",
    "fall": "abweichung",
    "wer": "ueberholender",
    "antwortAuf": "bs-ueberholen-bb-abgelehnt",
    "kleinfahrzeug": false,
    "lichtzeichen": true
  },
  {
    "id": "bs-ueberholen-stb-verlangt",
    "abschnitt": "C",
    "fundstelle": "§ 6.10 Nummer 2 Buchstabe b",
    "name": {
      "de": "2 lange Töne, 1 kurzer Ton",
      "en": "Two long blasts, one short blast"
    },
    "pattern": [
      {
        "kind": "lang",
        "count": 2
      },
      {
        "kind": "kurz",
        "count": 1
      }
    ],
    "repeatS": 0,
    "bedeutung": "Ich will auf Ihrer Steuerbordseite überholen",
    "erklaerung": "Zwei lange Töne und ein kurzer kündigen das Überholen auf der Steuerbordseite des Vorausfahrenden an. Die Zahl der kurzen Töne unterscheidet die Seite: einer für Steuerbord, zwei für Backbord.",
    "lage": "Überholen an Steuerbord des Vorausfahrenden verlangt",
    "wer": "ueberholender",
    "kleinfahrzeug": false,
    "lichtzeichen": true
  },
  {
    "id": "bs-ueberholen-stb-einverstanden",
    "abschnitt": "C",
    "fundstelle": "§ 6.10 Nummer 3",
    "name": {
      "de": "Kein Schallzeichen",
      "en": "No signal"
    },
    "pattern": [],
    "repeatS": 0,
    "bedeutung": "Einverstanden, Sie können auf meiner Steuerbordseite überholen",
    "erklaerung": "Auch hier heißt Schweigen Zustimmung. Gibt der Vorausfahrende kein Schallzeichen, darf auf seiner Steuerbordseite überholt werden.",
    "lage": "Überholen an Steuerbord des Vorausfahrenden verlangt",
    "fall": "normal",
    "wer": "vorausfahrender",
    "antwortAuf": "bs-ueberholen-stb-verlangt",
    "kleinfahrzeug": false,
    "lichtzeichen": false
  },
  {
    "id": "bs-ueberholen-stb-abgelehnt",
    "abschnitt": "C",
    "fundstelle": "§ 6.10 Nummer 4 Satz 1 Buchstabe a",
    "name": {
      "de": "1 kurzer Ton",
      "en": "One short blast"
    },
    "pattern": [
      {
        "kind": "kurz",
        "count": 1
      }
    ],
    "repeatS": 0,
    "bedeutung": "Nicht einverstanden, überholen Sie auf meiner Backbordseite",
    "erklaerung": "Ein kurzer Ton des Vorausfahrenden verlangt die Backbordseite. Der Überholende muss bestätigen.",
    "lage": "Überholen an Steuerbord des Vorausfahrenden verlangt",
    "fall": "abweichung",
    "wer": "vorausfahrender",
    "antwortAuf": "bs-ueberholen-stb-verlangt",
    "kleinfahrzeug": false,
    "lichtzeichen": true
  },
  {
    "id": "bs-ueberholen-stb-abgelehnt-bestaetigt",
    "abschnitt": "C",
    "fundstelle": "§ 6.10 Nummer 4 Satz 2 Buchstabe a",
    "name": {
      "de": "2 kurze Töne",
      "en": "Two short blasts"
    },
    "pattern": [
      {
        "kind": "kurz",
        "count": 2
      }
    ],
    "repeatS": 0,
    "bedeutung": "Einverstanden, ich werde auf Ihrer Backbordseite überholen",
    "erklaerung": "Zwei kurze Töne des Überholenden nehmen den Wunsch an. Er überholt nun auf der Backbordseite.",
    "lage": "Überholen an Steuerbord des Vorausfahrenden verlangt",
    "fall": "abweichung",
    "wer": "ueberholender",
    "antwortAuf": "bs-ueberholen-stb-abgelehnt",
    "kleinfahrzeug": false,
    "lichtzeichen": true
  },
  {
    "id": "bs-ueberholen-unmoeglich",
    "abschnitt": "C",
    "fundstelle": "§ 6.10 Nummer 5",
    "name": {
      "de": "5 kurze Töne",
      "en": "Five short blasts"
    },
    "pattern": [
      {
        "kind": "kurz",
        "count": 5
      }
    ],
    "repeatS": 0,
    "bedeutung": "Man kann mich nicht überholen",
    "erklaerung": "Fünf kurze Töne des Vorausfahrenden sagen, dass Überholen gerade nicht möglich ist, auf keiner Seite. Der Nachfolgende muss warten.",
    "lage": "Unmöglichkeit des Überholens",
    "wer": "vorausfahrender",
    "kleinfahrzeug": false,
    "lichtzeichen": true
  },
  {
    "id": "bs-wenden-stb",
    "abschnitt": "D",
    "fundstelle": "§ 6.13 Nummer 2 Buchstabe a, § 6.16 Nummer 2 Buchstabe c Doppelbuchstabe aa",
    "name": {
      "de": "1 langer Ton, 1 kurzer Ton",
      "en": "One long blast, one short blast"
    },
    "pattern": [
      {
        "kind": "lang",
        "count": 1
      },
      {
        "kind": "kurz",
        "count": 1
      }
    ],
    "repeatS": 0,
    "bedeutung": "Ich wende über Steuerbord",
    "erklaerung": "Ein langer und ein kurzer Ton kündigen eine Wende über Steuerbord an. Das Fahrzeug dreht quer zum Fahrwasser und braucht dafür Platz.",
    "kleinfahrzeug": false,
    "lichtzeichen": true
  },
  {
    "id": "bs-wenden-bb",
    "abschnitt": "D",
    "fundstelle": "§ 6.13 Nummer 2 Buchstabe b, § 6.16 Nummer 2 Buchstabe c Doppelbuchstabe bb",
    "name": {
      "de": "1 langer Ton, 2 kurze Töne",
      "en": "One long blast, two short blasts"
    },
    "pattern": [
      {
        "kind": "lang",
        "count": 1
      },
      {
        "kind": "kurz",
        "count": 2
      }
    ],
    "repeatS": 0,
    "bedeutung": "Ich wende über Backbord",
    "erklaerung": "Ein langer und zwei kurze Töne kündigen eine Wende über Backbord an. Wie bei den Allgemeinen Zeichen steht ein kurzer Ton für Steuerbord und zwei für Backbord.",
    "kleinfahrzeug": false,
    "lichtzeichen": true
  },
  {
    "id": "bs-hafen-stb",
    "abschnitt": "E",
    "fundstelle": "§ 6.16 Nummer 2 Satz 1 Buchstabe a",
    "name": {
      "de": "3 lange Töne, 1 kurzer Ton",
      "en": "Three long blasts, one short blast"
    },
    "pattern": [
      {
        "kind": "lang",
        "count": 3
      },
      {
        "kind": "kurz",
        "count": 1
      }
    ],
    "repeatS": 0,
    "bedeutung": "Ich will meinen Kurs nach Steuerbord richten",
    "erklaerung": "Drei lange Töne und ein kurzer kündigen bei der Ein- oder Ausfahrt aus einem Hafen oder einer Nebenwasserstraße einen Kurs nach Steuerbord an.",
    "kleinfahrzeug": false,
    "lichtzeichen": true
  },
  {
    "id": "bs-hafen-bb",
    "abschnitt": "E",
    "fundstelle": "§ 6.16 Nummer 2 Satz 1 Buchstabe b",
    "name": {
      "de": "3 lange Töne, 2 kurze Töne",
      "en": "Three long blasts, two short blasts"
    },
    "pattern": [
      {
        "kind": "lang",
        "count": 3
      },
      {
        "kind": "kurz",
        "count": 2
      }
    ],
    "repeatS": 0,
    "bedeutung": "Ich will meinen Kurs nach Backbord richten",
    "erklaerung": "Drei lange Töne und zwei kurze kündigen bei der Ein- oder Ausfahrt aus einem Hafen oder einer Nebenwasserstraße einen Kurs nach Backbord an.",
    "kleinfahrzeug": false,
    "lichtzeichen": true
  },
  {
    "id": "bs-hafen-ueberqueren",
    "abschnitt": "E",
    "fundstelle": "§ 6.16 Nummer 2 Satz 1 Buchstabe c",
    "name": {
      "de": "3 lange Töne",
      "en": "Three long blasts"
    },
    "pattern": [
      {
        "kind": "lang",
        "count": 3
      }
    ],
    "repeatS": 0,
    "bedeutung": "Ich will überqueren",
    "erklaerung": "Drei lange Töne ohne kurzen kündigen an, dass das Fahrzeug das Fahrwasser überqueren will, wenn es aus einem Hafen oder einer Nebenwasserstraße kommt.",
    "kleinfahrzeug": false,
    "lichtzeichen": true
  },
  {
    "id": "bs-nebel-fahrend",
    "abschnitt": "G",
    "fundstelle": "§ 6.33 Nummer 2 Satz 1, § 6.34 Nummer 3, auch in Verbindung mit Nummer 8 Satz 1",
    "name": {
      "de": "1 langer Ton, längstens jede Minute wiederholt",
      "en": "One long blast, at intervals of not more than one minute"
    },
    "pattern": [
      {
        "kind": "lang",
        "count": 1
      }
    ],
    "repeatS": 60,
    "bedeutung": "Einzeln fahrendes Fahrzeug und Verband, das oder der kein Radar benutzt",
    "erklaerung": "Bei unsichtigem Wetter gibt ein fahrendes Fahrzeug ohne Radar einen langen Ton, längstens jede Minute wiederholt. Wer ihn hört, weiß, dass sich da jemand ohne Radar durch den Nebel tastet.",
    "lage": "Einzeln fahrendes Fahrzeug und Verband, das oder der kein Radar benutzt",
    "kleinfahrzeug": false,
    "lichtzeichen": true
  },
  {
    "id": "bs-nebel-radar",
    "abschnitt": "G",
    "fundstelle": "§ 6.32 Nummer 2 Buchstabe d Doppelbuchstabe aa",
    "name": {
      "de": "1 langer Ton, wiederholt",
      "en": "One long blast, repeated"
    },
    "pattern": [
      {
        "kind": "lang",
        "count": 1
      }
    ],
    "repeatS": 10,
    "bedeutung": "Fahrzeug in der Radarfahrt, wenn kein Sprechfunkkontakt zustande kommt",
    "erklaerung": "Ein Fahrzeug in Radarfahrt gibt einen langen Ton, wenn es über Sprechfunk niemanden erreicht, und wiederholt ihn. Der Funk ist der erste Weg, das Horn der zweite.",
    "lage": "Fahrzeug in der Radarfahrt, wenn kein Sprechfunkkontakt zustande kommt",
    "kleinfahrzeug": false,
    "lichtzeichen": true
  },
  {
    "id": "bs-nebel-stillliegend",
    "abschnitt": "G",
    "fundstelle": "§ 6.31 Nummer 2, auch in Verbindung mit Nummer 3 Satz 2",
    "name": {
      "de": "1 Gruppe von Glockenschlägen, längstens jede Minute wiederholt",
      "en": "Group of bell strokes, at intervals of not more than one minute"
    },
    "pattern": [
      {
        "kind": "glocke",
        "count": 1
      }
    ],
    "repeatS": 60,
    "bedeutung": "Stillliegendes Fahrzeug",
    "erklaerung": "Ein stillliegendes Fahrzeug läutet bei unsichtigem Wetter eine Gruppe von Glockenschlägen, längstens jede Minute wiederholt. Die Glocke unterscheidet es hörbar vom fahrenden Fahrzeug mit seinem Horn.",
    "lage": "Stillliegendes Fahrzeug",
    "kleinfahrzeug": false,
    "lichtzeichen": false
  }
]
